import { render, staticRenderFns } from "./121.vue?vue&type=template&id=b285fa6a&scoped=true&"
var script = {}
import style0 from "./121.vue?vue&type=style&index=0&id=b285fa6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b285fa6a",
  null
  
)

export default component.exports